var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrrickLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 131,
    height: 132,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7A9C49",
    d: "M0 0h130.9v131.9H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 104.7c-2.8 0-5.8-.3-8.6-1C58.8 102 52 98 46.8 92.5c5.4 3.9 12 6 19 6 18 0 32.6-14.6 32.6-32.6 0-19.4-13.1-36.1-31.9-40.8-3.4-.9-6.8-1.2-10.2-1.2-9.8 0-19.1 3.4-26.5 9.4 9-9.9 21.9-15.7 35.7-15.7 26.7 0 48.4 21.7 48.4 48.4-.1 21.3-17.5 38.7-38.9 38.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4 114.3c-26.5 0-48.2-21.5-48.4-48.1v-.6C17.2 44.3 34.8 27 56.3 27c3 0 6.2.4 9.4 1.2C73.2 30 80 34.1 85.1 39.7c-5.5-4.1-12.4-6.4-19.4-6.4C49 33.4 35 46 33.3 62.6c-.1 1-.2 2.1-.2 3.3 0 1.2.1 2.3.2 3.3 1.4 18.4 14.5 33.4 32.4 37.5 3.1.7 6.3 1.1 9.5 1.1 9.3 0 18.3-3.2 25.5-8.9-9 9.8-21.8 15.4-35.3 15.4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrrickLogo);
export default __webpack_public_path__ + "static/media/orrick-logo.f501efa510f3a51afaa6e2e734889b34.svg";
export { ForwardRef as ReactComponent };